import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ProviderForm from "./ProviderForm";

const AddProviderDialog = ({ open, onOpenChange, onSuccess }) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} className="rounded-2xl sm:max-w-md w-[95vw] max-w-[95vw] overflow-hidden">
                <DialogHeader>
                    <DialogTitle>Add New Provider</DialogTitle>
                </DialogHeader>
                <ProviderForm
                    onSuccess={(provider) => {
                        onSuccess?.(provider);
                        onOpenChange(false);
                    }}
                    onCancel={() => onOpenChange(false)}
                />
            </DialogContent>
        </Dialog>
    );
};

export default AddProviderDialog;
